import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import ApiService from '../../services/ApiService';
import AddNote from './AddNote';
import { modal } from '../modal/ModalEmitter';
import RenderMd from '../../util/markdown';

const style = {
  height: '470px',
  display: 'flex',
  flexDirection: 'column',
};

const ViewNotes = ({ listName = '', listItem = '', callback }) => {
  const { user } = useSelector(state => state.app);
  const [showAddNote, setShowAddNote] = useState(false);
  const [noteList, setNoteList] = useState([]);

  const submitCallback = () => {
    setShowAddNote(false);

    fetchNotes().then(notes => {
      if (callback) {
        callback(notes);
      }
    });
  };

  const fetchNotes = () => {
    return ApiService.get('notes', { params: { listId: listName, itemId: listItem } }).then(response => {
      setNoteList(response.data);
      return response.data;
    });
  };

  const removeNote = noteId => {
    modal.confirm({
      message: 'Are you sure you want to delete this note?',
      callback: () => {
        ApiService.delete(`note/${noteId}`).then(response => {
          fetchNotes();

          if (callback) {
            callback();
          }
        });
      },
    });
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  if (showAddNote === true || noteList.length === 0) {
    return (
      <div className="view-notes" style={style}>
        <AddNote
          itemId={listItem}
          listId={listName}
          submitCallback={submitCallback}
          onCancel={noteList.length === 0 ? () => modal.close() : () => setShowAddNote(false)}
        />
      </div>
    );
  }

  return (
    <div className="view-notes" style={style}>
      <div className="note-list" style={{ flexGrow: '1', padding: '5px', overflowY: 'auto' }}>
        {noteList.map(note => {
          return (
            <div key={note.id}>
              <Card className="mb-2" style={{ backgroundColor: 'var(--yellow-0)' }}>
                <div className="card-toolbar">
                  {user.id === note.createdBy && (
                    <div className="card-toolbar-button" title="Delete Note" onClick={() => removeNote(note.id)}>
                      <i className="fas fa-trash-alt fa-fw" />
                    </div>
                  )}
                </div>
                <Card.Body>
                  <Card.Title>{note.title}</Card.Title>
                  <RenderMd className="custom-html-style" md={note.body} />
                </Card.Body>
                <Card.Footer>
                  <div className="d-flex justify-content-between">
                    <small>{moment(new Date(note.createdAt)).fromNow()}</small>
                    <small>{note.authorName}</small>
                  </div>
                </Card.Footer>
              </Card>
            </div>
          );
        })}
      </div>
      <div className="note-controls d-flex justify-content-between">
        <Button className="mt-2" variant="success" onClick={() => setShowAddNote(true)}>
          Add Note
        </Button>

        <Button className="mt-2" variant="seconardy" onClick={() => modal.close()}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default ViewNotes;
